import styled, { keyframes } from 'styled-components'
import { ReactComponent as LayersIcon } from '../../assets/img/layers-icon-mono.svg'
import { UIStyles } from '../../theme'

// Same icon as the loading screens, without the wordmark. Each layer pulses with its own delay.
const pulse = keyframes`
0% {
  transform: scale(0.85);
}
100% {
  transform: scale(1);
  opacity: 1;
}
`

const LayersLogo = styled(LayersIcon)`
  width: 110px;
  height: auto;
  display: inline-block;
  margin: auto;
  overflow: visible !important;
  color: ${UIStyles.whiteColor};
  path {
    transform-origin: center;
    animation: ${pulse} 1.5s ease-in-out infinite;
  }
  path:nth-of-type(1) {
    animation-delay: -1s;
  }
  path:nth-of-type(2) {
    animation-delay: -2s;
  }
  path:nth-of-type(3) {
    animation-delay: -3s;
  }
`

export default LayersLogo
